const BlogData = [
  {
    id: 1,
    image: "images/blog/2.jpeg",
    title: "The Cotton-Jersey Zip-Up Hoodie",
    description: `  Marketing Hub offers you all the latest eMail Marketing news,
    tools and resources to enable businesses and marketers to connect
    and harness the power of eMail Marketing.`,
    button: "READ MORE ........",
  },
  {
    id: 2,
    image: "images/blog/1.jpeg",
    title: "The Cotton-Jersey Zip-Up Hoodie",
    description: `  Marketing Hub offers you all the latest eMail Marketing news,
    tools and resources to enable businesses and marketers to connect
    and harness the power of eMail Marketing.`,
    button: "READ MORE ........",
  },
  {
    id: 3,
    image: "images/blog/3.webp",
    title: "The Cotton-Jersey Zip-Up Hoodie",
    description: `  Marketing Hub offers you all the latest eMail Marketing news,
    tools and resources to enable businesses and marketers to connect
    and harness the power of eMail Marketing.`,
    button: "READ MORE ........",
  },
  {
    id: 4,
    image: "images/blog/4.jpeg",
    title: "The Cotton-Jersey Zip-Up Hoodie",
    description: `  Marketing Hub offers you all the latest eMail Marketing news,
    tools and resources to enable businesses and marketers to connect
    and harness the power of eMail Marketing.`,
    button: "READ MORE ........",
  },
  {
    id: 5,
    image: "images/blog/5.webp",
    title: "The Cotton-Jersey Zip-Up Hoodie",
    description: `  Marketing Hub offers you all the latest eMail Marketing news,
    tools and resources to enable businesses and marketers to connect
    and harness the power of eMail Marketing.`,
    button: "READ MORE ........",
  },
  {
    id: 6,
    image: "images/blog/6.webp",
    title: "The Cotton-Jersey Zip-Up Hoodie",
    description: `  Marketing Hub offers you all the latest eMail Marketing news,
    tools and resources to enable businesses and marketers to connect
    and harness the power of eMail Marketing.`,
    button: "READ MORE ........",
  },
];
export default BlogData;
